module.exports = __webpack_public_path__ + "img/posud.90a54959.svg";